
import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../../services/authService/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '../../services/interceptor/loader.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApplicationInfoDTO } from 'src/app/components/user/dto/AdministratorDTO';

var body = document.getElementsByTagName("body")[0];

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public menuItems: Menu[];
  public items: Menu[];
  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public openNav: boolean = false
  public right_sidebar: boolean = false
  public text: string;
  public elem;
  baseUrl=environment.baseURL
  logoImage='auth/logoImage'
  appInfo:ApplicationInfoDTO=new ApplicationInfoDTO()
  public isOpenMobile: boolean = false
  @Output() rightSidebarEvent = new EventEmitter<boolean>();
  public currentLang: string;
  user = localStorage.getItem('userData');

  constructor(
    public navServices: NavService,
    @Inject(DOCUMENT) private document: any,
    private translate: TranslateService,
    public authService: AuthService, private cookieService: CookieService,
    public loader: LoaderService,
    private router: Router) {
      
    
  }


  ngOnDestroy() {
    this.removeFix();
  }

  editUserProfile(){
    this.router.navigate(['/users/edit-profile']);
  }


  right_side_bar() {
    this.right_sidebar = !this.right_sidebar
    this.rightSidebarEvent.emit(this.right_sidebar)
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  public changeLanguage(lang) {
    
    //setTimeout(()=>{
    
     
      setTimeout(async() =>{
        // if(localStorage.getItem('recentPath') && localStorage.getItem('recentPath')!='/error/404' && location.pathname!=localStorage.getItem('recentPath')) {
          await   localStorage.setItem("lang", lang);
          await  this.translate.use(lang);
          await  this.navServices.changeLanguageMenu(lang)
        // }
        await window.location.reload()
      
           
        },0)
          
      
      // this.navServices.items2.subscribe(menuItems => {
      //   
      //location.reload();
    //}, 100)
    
  }

  searchTerm(term: any) {
    term ? this.addFix() : this.removeFix();
    if (!term) return this.menuItems = [];
    let items = [];
    term = term.toLowerCase();
    this.items.filter(menuItems => {
      if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
        items.push(menuItems);
      }
      if (!menuItems.children) return false
      menuItems.children.filter(subItems => {
        if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
          subItems.icon = menuItems.icon
          items.push(subItems);
        }
        if (!subItems.children) return false
        subItems.children.filter(suSubItems => {
          if (suSubItems.title.toLowerCase().includes(term)) {
            suSubItems.icon = menuItems.icon
            items.push(suSubItems);
          }
        })
      })
      this.checkSearchResultEmpty(items)
      this.menuItems = items
    });
  }

  checkSearchResultEmpty(items) {
    if (!items.length)
      this.searchResultEmpty = true;
    else
      this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    body.classList.add("offcanvas");
  }

  removeFix() {
    this.searchResult = false;
    body.classList.remove("offcanvas");
    this.text = "";
  }
  ngOnInit() {
    this.authService.getApplicationInfo().subscribe((resp:any)=>{
      if(resp)
      this.appInfo=resp.data
      // console.log("appinfo2 "+(JSON.stringify(this.appInfo)))
    },(error:any)=>{
      console.log("error "+error.error.message)
    })
    this.elem = document.documentElement;
    this.navServices.items.subscribe(menuItems => {
      this.items = menuItems
    });
    if(this.cookieService.check('language')){
      this.translate.setDefaultLang(this.cookieService.get('language'));
    }
    else{
      this.translate.setDefaultLang(localStorage.getItem('lang'));  
    }
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
